import { render, staticRenderFns } from "./PromotionProductExp.vue?vue&type=template&id=3515b9d9&scoped=true&"
import script from "./PromotionProductExp.vue?vue&type=script&lang=js&"
export * from "./PromotionProductExp.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3515b9d9",
  null
  
)

export default component.exports